export default "__VITE_ASSET__CkpAONKG__"